// extracted by mini-css-extract-plugin
export default {"separator":"LineSeparator_separator__kshgY","sideBars":"LineSeparator_sideBars__GMtd8"};